import { call, put, takeEvery, select } from 'redux-saga/effects'
import {
	successMessage,
	loadingMessage,
	errorMessage,
} from '~/services/messager'
import api from '~/services/api'
import DocumentDetailsService from '~/services/DocumentDetailsService'
import {
	getDocumentDetail,
	getDocumentDetailSuccess,
	getDocumentDetailFailure,
	newVersion,
	newVersionSuccess,
	newVersionFailure,
	previousStep,
	previousStepSuccess,
	previousStepFailure,
	nextStep,
	nextStepSuccess,
	nextStepFailure,
	archive,
	archiveSuccess,
	archiveFailure,
	editStep,
	editStepSuccess,
	editStepFailure,
	editSigners,
	editSignersSuccess,
	editSignersFailure,
	sendForSigning,
	sendForSigningSuccessClickSign,
	sendForSigningSuccess,
	sendForSigningFailure,
	selectVersion,
	selectVersionSuccess,
	selectVersionFailure,
	downloadLink,
	downloadLinkSuccess,
	downloadLinkFailure,
	getDocumentWordDownload,
	getDocumentWordDownloadSuccess,
	getDocumentWordDownloadFailure,
	changeVariables,
	changeVariablesSuccess,
	changeVariablesFailure,
	changeConfigs,
	changeConfigsSuccess,
	changeConfigsFailure,
	getDocumentCertificate,
	getDocumentCertificateFailure,
	downloadTextDocumentVersion,
	downloadTextDocumentVersionSuccess,
	downloadTextDocumentVersionFailure,
	cancelDocument,
	cancelDocumentSuccess,
	cancelDocumentFailure,
	getAttachments,
	getAttachmentsSuccess,
	getAttachmentsFailure,
	getAddendumUrl,
	getAddendumUrlSuccess,
	getAddendumUrlFailure,
	getTerminationUrl,
	getTerminationUrlSuccess,
	getTerminationUrlFailure,
	getDocumentsUrl,
	getDocumentsUrlSuccess,
	getDocumentsUrlFailure,
} from '.'

import axios from 'axios'

export default function* rootSaga() {
	yield takeEvery(getDocumentDetail, getDocumentDetailSaga)
	yield takeEvery(newVersion, newVersionSaga)
	yield takeEvery(previousStep, previousStepSaga)
	yield takeEvery(nextStep, nextStepSaga)
	yield takeEvery(archive, archiveSaga)
	yield takeEvery(editStep, editStepSaga)
	yield takeEvery(editSigners, editSignersSaga)
	yield takeEvery(sendForSigning, sendForSigningSaga)
	yield takeEvery(selectVersion, selectVersionSaga)
	yield takeEvery(downloadLink, downloadLinkSaga)
	yield takeEvery(getDocumentWordDownload, getDocumentWordDownloadSaga)
	yield takeEvery(changeVariables, changeVariablesSaga)
	yield takeEvery(changeConfigs, changeConfigsSaga)
	yield takeEvery(getDocumentCertificate, getDocumentCertificateSaga)
	yield takeEvery(downloadTextDocumentVersion, downloadTextDocumentVersionSaga)
	yield takeEvery(cancelDocument, cancelDocumentSaga)
	yield takeEvery(getAttachments, getAttachmentsSaga)
	yield takeEvery(getAddendumUrl, getAddendumUrlSaga)
	yield takeEvery(getTerminationUrl, getTerminationUrlSaga)
	yield takeEvery(getDocumentsUrl, getDocumentsUrlSaga)
}

function* getDocumentCertificateSaga({ payload = {} }) {
	const { id } = payload
	try {
		const { data } = yield call(api.get, `/documents/${id}/certificate`)
		window.location.href = data.data.url
	} catch (error) {
		yield put(getDocumentCertificateFailure(error))
	}
}

function* getDocumentDetailSaga({ payload = {} }) {
	const { id } = payload
	try {
		const { data } = yield call(api.get, `/documents/${id}`)

		let response
		if (!data.draft) {
			if (data.text_type === '.docx') {
				response = yield call(api.get, `/documents/${data.id}/pdf`)
			} else if (data.text_type === 'upload') {
				response = yield call(api.get, `/documents/${data.id}/pdf`)
			} else if (data.text_type === '.pdf') {
				response = yield call(api.get, `/documents/${data.id}/pdf`)
			} else {
				response = yield call(api.get, `/documents/${data.id}/text`)
			}
		}
		yield put(getDocumentDetailSuccess({ ...data, ...(response?.data || {}) }))
	} catch (error) {
		errorMessage({
			content:
				'Ooops, ocorreu um erro. Já avisamos nossos engenheiros, por favor tente mais tarde.',
			updateKey: 'getDocumentDetail',
		})
		yield put(getDocumentDetailFailure(error))
	}
}

function* newVersionSaga({ payload = {} }) {
	loadingMessage({
		content: 'Criando nova versão do documento...',
		updateKey: 'createVersion',
	})
	const { id, description, text } = payload
	const { documentDetail } = yield select()
	try {
		const response = yield call(api.post, `/documents/${id}/text`, {
			text: text.text,
			description,
			comments: text.comments,
		})
		successMessage({
			content: 'Versão criada com sucesso',
			updateKey: 'createVersion',
		})

		let version_id = response.data.updated_versions_list[0].id

		yield put(
			newVersionSuccess({
				text: response.data.uploaded_text,
				versions: response.data.updated_versions_list,
				document: { ...documentDetail.data, version_id },
				version_id,
			})
		)
	} catch (error) {
		yield put(newVersionFailure(error))
	}
}

function* selectVersionSaga({ payload = {} }) {
	loadingMessage({
		content: 'Selecionando versão do documento...',
		updateKey: 'selectVersion',
	})
	const { id } = payload
	const { documentDetail } = yield select()
	try {
		let response

		if (documentDetail.data.text_type === '.docx') {
			response = yield call(
				api.get,
				`/documents/${documentDetail.data.id}/pdf?version=${id}`
			)
		} else {
			response = yield call(
				api.get,
				`/documents/${documentDetail.data.id}/text?version=${id}`
			)
		}
		successMessage({
			content: 'Versão selecionada com sucesso.',
			updateKey: 'selectVersion',
		})
		yield put(
			selectVersionSuccess({
				text: response.data.text ? response.data.text : '',
				file: response.data.download_url ? response.data.download_url : '',
				comments: response.data.comments,
				document: {
					...documentDetail.data,
					version_id: response.data.version_id,
				},
				version_id: response.data.version_id,
			})
		)
	} catch (error) {
		errorMessage({
			content: 'Seleção de versão falhou.',
			updateKey: 'selectVersion',
		})
		yield put(selectVersionFailure(error))
	}
}

function* sendForSigningSaga({ payload = {} }) {
	const { id } = payload
	const { session } = yield select()
	const { signatures_provider = null } = session

	try {
		if (signatures_provider === 'docusign') {
			loadingMessage({
				content: 'Enviando documento para assinatura via Docusign.',
				updateKey: 'sendForSigning',
			})
			const responseDocusign = yield call(api.post, `/documents/sign`, {
				document_id: id,
			})
			if (responseDocusign.data.sent) {
				successMessage({
					content: 'Enviamos, via Docusign, o documento para assinatura.',
					updateKey: 'sendForSigning',
				})
				yield put(sendForSigningSuccess({ ...responseDocusign.data }))
			} else {
				errorMessage({
					content:
						'Envio para Docusign falhou, favor revisar os dados dos signatários.',
					updateKey: 'sendForSigning',
				})
				yield put(sendForSigningFailure())
			}
		}

		if (signatures_provider === 'd4sign') {
			loadingMessage({
				content: 'Enviando documento para assinatura via D4sign.',
				updateKey: 'sendForSigning',
			})
			const responseD4sign = yield call(
				api.post,
				`/d4sign/upload-and-send-document-for-signing/`,
				{
					document_id: id,
				}
			)
			successMessage({
				content: 'Enviamos, via D4sign, o documento para assinatura.',
				updateKey: 'sendForSigning',
			})
			yield put(sendForSigningSuccess({ ...responseD4sign.data }))
		}

		if (signatures_provider === 'clicksign') {
			loadingMessage({
				content: 'Enviando documento para assinatura via Clicksign.',
				updateKey: 'sendForSigning',
			})

			const responseclicksign = yield call(() =>
				axios.post(`${process.env.REACT_APP_CLICKSIGN_URL}`, {
					document_id: id,
				})
			)
			if (responseclicksign.status === 200) {
				successMessage({
					content: 'Enviamos, via Clicksign, o documento para assinatura.',
					updateKey: 'sendForSigning',
				})
			}
			yield put(sendForSigningSuccessClickSign())
			window.location.reload()
		}
	} catch (error) {
		let showConnectModal = false
		yield put(sendForSigningFailure({ error, showConnectModal }))

		if (signatures_provider === 'docusign') {
			if (
				error.response?.data?.message?.includes('Invalid Docusign access token')
			) {
				showConnectModal = true
			}
			errorMessage({
				content:
					error.response?.data?.message || 'Erro desconhecido no Docusign',
				updateKey: 'sendForSigning',
			})
		} else if (signatures_provider === 'clicksign') {
			errorMessage({
				content:
					error.response?.data?.message || 'Erro ao conectar com a Clicksign',
				updateKey: 'sendForSigning',
			})
		} else {
			errorMessage({
				content: 'Erro ao conectar com a assinatura',
				updateKey: 'sendForSigning',
			})
		}
	}
}

function* editSignersSaga({ payload = {} }) {
	const { id, signers } = payload
	const {
		documentDetail: { data: document },
	} = yield select()
	const reqPayload = {
		...signers,
		icp_signing: document.signers?.icp_signing || false,
	}
	try {
		const response = yield call(
			api.post,
			`/documents/${id}/signers`,
			reqPayload
		)
		yield put(editSignersSuccess({ ...response.data }))
	} catch (error) {
		yield put(editSignersFailure(error))
	}
}

function* previousStepSaga({ payload }) {
	loadingMessage({
		content: 'Mudando o status do documento. Por favor aguarde.',
		updateKey: 'status',
	})
	const { id } = payload
	try {
		const response = yield call(api.get, `documents/${id}/previous`)
		yield put(previousStepSuccess(response.data))
		successMessage({
			content: 'Alteração do status do documento realizada com sucesso.',
			updateKey: 'status',
		})
	} catch (error) {
		errorMessage({
			content: 'Alteração do status do documento falhou.',
			updateKey: 'status',
		})
		yield put(previousStepFailure(error))
	}
}

function* nextStepSaga({ payload = {} }) {
	loadingMessage({
		content: 'Mudando o status do documento. Por favor aguarde.',
		updateKey: 'status',
	})
	const { id } = payload
	try {
		const response = yield call(api.post, `workflow/${id}/next`)
		yield put(nextStepSuccess(response.data))
		successMessage({
			content: 'Alteração do status do documento realizada com sucesso.',
			updateKey: 'status',
		})
	} catch (error) {
		errorMessage({
			content: 'Alteração do status do documento falhou.',
			updateKey: 'status',
		})
		yield put(nextStepFailure(error))
	}
}

function* archiveSaga({ payload = {} }) {
	loadingMessage({
		content: 'Arquivando o documento. Por favor aguarde.',
		updateKey: 'archive',
	})
	const { id } = payload

	try {
		const response = yield call(api.post, `workflow/${id}/archive`)
		yield put(archiveSuccess(response.data))
		successMessage({
			content: 'Documento arquivado com sucesso.',
			updateKey: 'archive',
		})
	} catch (error) {
		errorMessage({
			content: 'Falha ao arquivar o documento.',
			updateKey: 'archive',
		})
		yield put(archiveFailure(error))
	}
}

function* editStepSaga({ payload = {} }) {
	loadingMessage({
		content: 'Mudando o status do documento. Por favor aguarde.',
		updateKey: 'status',
	})
	const { id, responsible_group, due_date } = payload
	try {
		const response = yield call(api.patch, `workflow/${id}`, {
			responsible_group,
			due_date,
		})
		yield put(editStepSuccess(response.data))
		successMessage({
			content: 'Alteração do status do documento realizada com sucesso.',
			updateKey: 'status',
		})
	} catch (error) {
		errorMessage({
			content: 'Alteração do status do documento falhou.',
			updateKey: 'status',
		})
		yield put(editStepFailure(error))
	}
}

function* downloadLinkSaga({ payload = {} }) {
	const { id } = payload
	try {
		const response = yield call(api.get, `documents/${id}/download`)
		window.open(response.data.download_url, '_blank', 'noopener,noreferrer')

		yield put(downloadLinkSuccess())
	} catch (error) {
		yield put(downloadLinkFailure(error))
	}
}

function* getDocumentWordDownloadSaga({ payload = {} }) {
	loadingMessage({
		content: 'Realizando download do documento...',
		updateKey: 'downloadWord',
	})
	const { id, filename = 'document.docx' } = payload
	try {
		const { data } = yield call(api.get, `documents/${id}/docx`)

		axios
			.get(data.download_url, { responseType: 'blob' })
			.then(
				(response) =>
					new Blob([response.data], { type: response.headers['content-type'] })
			)
			.then((blob) => {
				const href = window.URL.createObjectURL(blob)

				const link = document.createElement('a')
				link.setAttribute('href', href)
				link.setAttribute('download', filename)

				let clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: false,
				})

				link.dispatchEvent(clickEvent)
			})
			.catch((err) => console.error(err))

		successMessage({
			content: 'Download realizado com sucesso.',
			updateKey: 'downloadWord',
		})
		yield put(getDocumentWordDownloadSuccess())
	} catch (error) {
		errorMessage({
			content: 'Download falhou, favor tente novamente.',
			updateKey: 'downloadWord',
		})
		yield put(getDocumentWordDownloadFailure(error))
	}
}

function* changeVariablesSaga({ payload = {} }) {
	loadingMessage({
		content: 'Alterando váriaveis do documento...',
		updateKey: 'variablesDocument',
	})
	const { id, values, history } = payload
	const { documentDetail } = yield select()
	const { imgObj } = documentDetail.data

	// This function nests the struct variables, since Form only supports single level nesting
	const arrangeStructs = (values) => {
		Object.keys(values).forEach((fieldName) => {
			if ((values[fieldName] === undefined) | (values[fieldName] === '')) {
				delete values[fieldName]
			} else if (fieldName.slice(0, 10) === 'structured') {
				let arranged = []
				Object.keys(values[fieldName]).forEach((structVar) => {
					if (parseInt(structVar.split('_').pop()) + 1 > arranged.length) {
						arranged.push({})
					}
				})

				Object.keys(values[fieldName]).forEach((structVar) => {
					const nameSplit = structVar.split('_')
					const index = parseInt(nameSplit.pop())
					const name = nameSplit.join('_')
					arranged[index][name] = values[fieldName][structVar]
				})
				values[fieldName] = arranged
			} else if (fieldName.slice(0, 19) === 'structured_checkbox') {
				let arranged = []
				Object.entries(values[fieldName]).forEach((variable) => {
					if (Array.isArray(variable[1])) {
						variable[1].forEach((option) => {
							const optionObj = { OPTION: option }
							Object.entries(values[fieldName]).forEach((optionDetail) => {
								if (optionDetail[0].split('_').slice(-1)[0] === option) {
									const newName = optionDetail[0].split('_')
									newName.pop()
									optionObj[newName.join('_')] = optionDetail[1]
								}
							})
							arranged.push(optionObj)
						})
					}
				})
				values[fieldName] = arranged
			}
		})
		return values
	}

	arrangeStructs(values)

	try {
		let dataImg = {}

		for (var [key] of Object.entries(values)) {
			if (key.includes('image_')) {
				dataImg[key] = document
					.getElementById(key)
					.getElementsByTagName('input')[0].value
			}
		}

		Object.keys(dataImg).forEach((key) => {
			if (dataImg[key] === '') {
				delete dataImg[key]
				delete values[key]
			}
		})

		const { data } = yield call(api.post, `documents/${id}/modify`, {
			variables: { ...imgObj, ...values, ...dataImg },
		})

		const response = yield call(api.get, `/documents/${id}/pdf`)
		successMessage({
			content: 'Alteração realizada com sucesso.',
			updateKey: 'variablesDocument',
		})
		history.push(`/documents/${id}`)
		yield put(changeVariablesSuccess({ ...data, ...response.data }))
	} catch (error) {
		errorMessage({
			content: 'Alteração falhou, favor tente novamente.',
			updateKey: 'variablesDocument',
		})
		yield put(changeVariablesFailure(error))
	}
}

function* changeConfigsSaga({ payload = {} }) {
	loadingMessage({
		content: 'Alterando configurações do documento...',
		updateKey: 'documentConfigs',
	})
	const { id, configs } = payload
	const { documentDetail } = yield select()

	try {
		const { data } = yield call(api.patch, `documents/${id}/configs`, {
			configs,
		})

		successMessage({
			content: 'Alteração realizada com sucesso.',
			updateKey: 'documentConfigs',
		})

		if (['.docx', '.pdf', 'upload'].includes(documentDetail.data.text_type)) {
			const response = yield call(api.get, `/documents/${id}/pdf`)
			return yield put(changeConfigsSuccess({ ...data, ...response.data }))
		}

		yield put(changeConfigsSuccess({ ...data }))
	} catch (error) {
		errorMessage({
			content: 'Alteração falhou, favor tente novamente.',
			updateKey: 'documentConfigs',
		})
		yield put(changeConfigsFailure(error))
	}
}

function* downloadTextDocumentVersionSaga({ payload }) {
	try {
		loadingMessage({
			content: 'Realizando download do documento...',
			updateKey: 'downloadWordVersion',
		})
		const data = yield call(DocumentDetailsService.downloadPdf, payload)
		yield put(downloadTextDocumentVersionSuccess(data))
		successMessage({
			content: 'Documento baixado com sucesso!',
			updateKey: 'downloadWordVersion',
		})
	} catch (error) {
		console.log(error)
		errorMessage({
			content: 'Ocorreu um erro ao baixar o seu documento.',
			updateKey: 'downloadWordVersion',
		})
		yield put(downloadTextDocumentVersionFailure(error))
	}
}

function* cancelDocumentSaga({ payload }) {
	const id = payload
	const { session } = yield select()
	const { signatures_provider = null } = session

	loadingMessage({
		content: 'Cancelando documento...',
		updateKey: 'cancelDocument',
	})

	try {
		let data

		if (signatures_provider === 'docusign') {
			const response = yield call(api.put, `documents/${id}/void`)
			data = response.data
			successMessage({
				content: 'Documento cancelado via DocuSign.',
				updateKey: 'cancelDocument',
			})
		} else if (signatures_provider === 'd4sign') {
			const response = yield call(api.put, `/d4sign/cancel-document/${id}`)
			data = response.data
			successMessage({
				content: 'Documento cancelado via D4Sign.',
				updateKey: 'cancelDocument',
			})
		} else {
			throw new Error('Provedor de assinatura não suportado para cancelamento.')
		}

		yield put(cancelDocumentSuccess(data))
		successMessage({
			content: 'Documento cancelado com sucesso!',
			updateKey: 'cancelDocument',
		})
	} catch (error) {
		errorMessage({
			content: 'Ocorreu um erro ao cancelar o documento.',
			updateKey: 'cancelDocument',
		})
		yield put(cancelDocumentFailure(error))
	}
}

function* getAttachmentsSaga({ payload = {} }) {
	const { id } = payload
	try {
		const { data } = yield call(api.get, `/documents/${id}/attachments`)
		yield put(getAttachmentsSuccess(data))
	} catch (error) {
		yield put(getAttachmentsFailure(error))
	}
}

function* getAddendumUrlSaga({ payload }) {
	const { id } = payload
	try {
		const { data } = yield call(api.get, `/documents/${id}/addendums`)
		yield put(getAddendumUrlSuccess(data))
	} catch (error) {
		yield put(getAddendumUrlFailure(error))
	}
}

function* getTerminationUrlSaga({ payload }) {
	const { id } = payload
	try {
		const { data } = yield call(api.get, `/documents/${id}/termination`)

		if (data.download_url) {
			const termination = yield select(
				(state) => state.documentDetail.data?.termination
			)
			if (termination && termination.filename) {
				const urls = { [termination.filename]: data.download_url }
				yield put(getTerminationUrlSuccess(urls))
			}
		}
	} catch (error) {
		yield put(getTerminationUrlFailure(error))
	}
}

function* getDocumentsUrlSaga({ payload }) {
	const { id } = payload
	try {
		const { data } = yield call(api.get, `/documents/${id}/documents`)
		yield put(getDocumentsUrlSuccess(data))
	} catch (error) {
		yield put(getDocumentsUrlFailure(error))
	}
}
